import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const ValidationModal = ({
  show,
  onClose,
  onValidate,
  messageIndex,
  id,
  isEditingContext,
}) => {
  const history = useHistory();

  const handleValidate = async () => {
    try {
      await onValidate(messageIndex);
      history.push(`/questoes/register/${id}`);
      onClose();
    } catch (error) {
      console.error("Erro ao validar a questão:", error);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
          Validar Questão
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ padding: "1.5rem", fontSize: "1rem", lineHeight: "1.5" }}
      >
        <p>
          Essa questão foi criada por IA. Você deve confirmar a qualidade da
          questão gerada.
        </p>
        <p>Você tem certeza que deseja validar esta questão?</p>
        {isEditingContext && (
          <div style={{ color: "red", fontWeight: "bold", marginTop: "1rem" }}>
            Certifique-se de definir o contexto da questão.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleValidate}
          disabled={isEditingContext}
        >
          Validar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ValidationModal;
